import { HELP_CENTER_URL } from "@/config/constants";

declare global {
    interface Window {
        Beacon?: (method: string, ...args: unknown[]) => void;
        attachEvent?: (event: string, callback: () => void) => void;
    }
}

// The Beacon embed snippet stubs window.Beacon with a call queue before the
// real script loads, so only the SDK's "ready" event proves the popup can open.
let beaconReady = false;

export const setBeaconReady = (ready: boolean) => {
    beaconReady = ready;
};

export const openHelpBeacon = () => {
    if (beaconReady && window.Beacon) {
        window.Beacon("open");
        return;
    }
    window.open(HELP_CENTER_URL, "_blank", "noopener,noreferrer");
};
